export const SUPPORT_SEND_REQUEST = "SUPPORT_SEND_REQUEST";
export const SUPPORT_SEND_SUCCESS = "SUPPORT_SEND_SUCCESS";
export const SUPPORT_SEND_FAIL = "SUPPORT_SEND_FAIL";
export const SUPPORT_SEND_RESET = "SUPPORT_SEND_RESET";
